import styled from 'styled-components';
import { METRIC_VALUES_TO_LABELS } from 'constants/metricValuesToLabels';
import { colors, spacing } from 'ui/theme';
import { Expression } from '../types';

const tooltipTheme = {
  background: colors.purple90,
  hr: colors.white,
};

type ContainerProps = {
  variant: string | undefined;
};

const Container = styled.div<ContainerProps>`
  display: flex;
  font-family: 'Lucida Console', 'Courier New', monospace;
  flex-direction: column;
  align-items: center;
  background: ${(props) => (props.variant === 'tooltip' ? tooltipTheme.background : colors.cyan10)};
  border-radius: ${spacing.base};
  padding: ${spacing.base};
  width: fit-content;
`;

type LineProps = {
  variant: string | undefined;
};

const Line = styled.hr<LineProps>`
  width: 100%;
  border-top: ${spacing.single} solid
    ${(props) => (props.variant === 'tooltip' ? tooltipTheme.hr : colors.grey80)};
  margin: ${spacing.eighth};
`;

const operators: Record<string, string> = {
  Minus: '-',
  Plus: '+',
  Times: '*',
};

type FormulaProps = {
  numerator: Expression | string;
  denominator?: Expression | string;
  variant?: string;
  codeView?: boolean;
};

export const Formula = ({ numerator, denominator, variant, codeView }: FormulaProps) => {
  const formatLabel = (name: string) => {
    // Mille metrics
    if (name === '1000') {
      return name;
    } else {
      return codeView ? name : METRIC_VALUES_TO_LABELS[name];
    }
  };

  const formatExpression = (expression: Expression | string) => {
    if (typeof expression === 'string') {
      return formatLabel(expression);
    }
    const { first, second, operator } = expression;
    return `${formatLabel(first)} ${operators[operator]} ${formatLabel(second)}`;
  };
  return (
    <Container variant={variant}>
      {formatExpression(numerator)}
      {denominator && <Line variant={variant} />}
      {denominator && formatExpression(denominator)}
    </Container>
  );
};
